/* global G */
import { modelComposition } from 'trait/composition'
import { withGetterSetter } from 'trait/with'
import { usesGetterSetter } from 'trait/uses'
import validator from 'model/installationReport/validator'
import { pipe } from 'lib/util'
import toAddress from 'model/_shared/transformer/toAddress'
import fromAddress from 'model/_shared/decorator/fromAddress'
import toRef from 'model/_shared/transformer/toRef'
import fromSingleRef from 'model/_shared/decorator/fromSingleRef'
import toInstallationDate from 'model/installationReport/transformer/toInstallationDate'
import toExplicitBoolean from 'model/_shared/transformer/toExplicitBoolean'

const descriptor = 'model::installationReport'

export default pipe(
  modelComposition(descriptor),
  withGetterSetter(G.VALIDATOR),
  usesGetterSetter(G.VALIDATOR, validator),
  usesGetterSetter(G.TRANSFORMER, {
    address: toAddress('address'),
    installationDateUnknown: toExplicitBoolean('installationDateUnknown'),
    installationDate: toInstallationDate('installationDate'),
    equipment: toRef('equipment'),
    submitter: toRef('submitter'),
    installedBy: toRef('installedBy'),
  }),
  withGetterSetter(G.DECORATOR),
  usesGetterSetter(G.DECORATOR, {
    address: fromAddress('address'),
    equipment: fromSingleRef('equipment'),
    submitter: fromSingleRef('submitter'),
    installedBy: fromSingleRef('installedBy'),
  }),
)
